// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"14ed0d08","859":"0fd505e3"}[chunkId] + ".chunk.css";
};